import { useTranslation } from "react-i18next"
import { MouseEvent, useState } from "react"
import { useStore } from "../../../contexts/store"
import { Op_deleteTag } from "../../../shared/src/types/Ops"

import ConfirmDialog from "../../Elements/ConfirmDialog"
import UxIcon from "../../Elements/UxIcon"
import { IconButton } from "@mui/material"

const DeleteTagDialog = ({tagId, tagName, podId}: {tagId: string, tagName: string, podId: string}) => {
  const { t } = useTranslation()
  const { opStore, podStore, sessionStore } = useStore()
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)

  const session = sessionStore.session
  if (!session) return null

  function handleDeleteTag(tagId: string) {
    if(tagId && session) {
      const op:Op_deleteTag = {
        op: 'deleteTag',
        podId: podId,
        data: {
          tagId: tagId,
          userId: session.user.userId,
          userName: podStore.userPseudonym as string,
          usergroupId: podStore.getUsergroupByRole('Pod').usergroupId
        }
      }
      opStore.doOp(op)
    }
  }

  return (
    <>
      <IconButton sx={{padding: "10px"}} size="small" onClick={(e: MouseEvent) => {e.stopPropagation(); setShowDeleteDialog(true)}}>
        <UxIcon fontSize="small" id="delete" />
      </IconButton>
      <ConfirmDialog
        handleClose={() => setShowDeleteDialog(false) }
        info={t('All Taggings associated with the Tag will also be deleted.') ||''}
        onOk={() => {handleDeleteTag(tagId)}}
        open={showDeleteDialog}
        title={t('Delete Tag') + ` #${tagName}`}
      />
    </>
  )
}

export default DeleteTagDialog
